import { render, staticRenderFns } from "./SGKExitOttView.vue?vue&type=template&id=53b5e889&"
import script from "./SGKExitOttView.vue?vue&type=script&lang=js&"
export * from "./SGKExitOttView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports